import { MetricModel } from 'src/app/shared/models/metric.model'
import { roadHazardLegendObstacles } from '../utils/simulation-legend-utils'
import { defaultExpression, defaultLegend } from 'src/app/shared/utils/metric.utils'
import { createPaintExpression } from '../utils/simulation-paint-utils'

export enum SimulationMetrics {
  Warnings_LowVisibility = 'lv',
  Warnings_Accidents = 'va',
  Warnings_BrokenDownVehicle = 'bdv',
  Warnings_TractionLoss = 'tl',
  Warnings_ConstructionSite = 'cs',
  Warnings_HeavyRain = 'hr',
  Warnings_HeavySnow = 'hs',
  Warnings_StrongWind = 'sw',
  Warnings_PoorRoad = 'pr',
  Warnings_WrongWayDriver = 'wwd',
  Warnings_ItemOnRoad = 'ior',
  Warnings_AmberLightVehicle = 'al',
  Warnings_BlueLightVehicle = 'bl',
  Warnings_StoppedVehicle = 'sv',
  Warnings_TrafficJamTail = 'tjt',
}

export const getMetricFromMap = (metric: string): MetricModel => {
  return (
    CustomerMetricMap.get(metric) || {
      displayName: 'Default',
      expression: defaultExpression,
      name: 'default',
      icon: 'question',
      key: 'default',
      legend: defaultLegend,
    }
  )
}

export const CustomerMetricMap = new Map<string, MetricModel>()

CustomerMetricMap.set(SimulationMetrics.Warnings_Accidents, {
  name: 'accident',
  expression: createPaintExpression('accident'),
  icon: 'car-crash',
  key: SimulationMetrics.Warnings_Accidents,
  displayName: 'Accidents',
  legend: roadHazardLegendObstacles,
})

CustomerMetricMap.set(SimulationMetrics.Warnings_BrokenDownVehicle, {
  name: 'brokenDownVehicle',
  expression: createPaintExpression('brokenDownVehicle'),
  icon: 'car-mechanic',
  key: SimulationMetrics.Warnings_BrokenDownVehicle,
  displayName: 'BDV',
  legend: roadHazardLegendObstacles,
})

CustomerMetricMap.set(SimulationMetrics.Warnings_ConstructionSite, {
  name: 'constructionSite',
  expression: createPaintExpression('constructionSite'),
  icon: 'construction',
  key: SimulationMetrics.Warnings_ConstructionSite,
  displayName: 'Construction Site',
  legend: roadHazardLegendObstacles,
})

CustomerMetricMap.set(SimulationMetrics.Warnings_LowVisibility, {
  name: 'lowVisibility',
  expression: createPaintExpression('lowVisibility'),
  icon: 'weather-mist',
  key: SimulationMetrics.Warnings_LowVisibility,
  displayName: 'Low Visibility',
  legend: roadHazardLegendObstacles,
})

CustomerMetricMap.set(SimulationMetrics.Warnings_TractionLoss, {
  name: 'tractionLoss',
  expression: createPaintExpression('tractionLoss'),
  icon: 'wheel-vehicle',
  key: SimulationMetrics.Warnings_TractionLoss,
  displayName: 'Traction Loss',
  legend: roadHazardLegendObstacles,
})

CustomerMetricMap.set(SimulationMetrics.Warnings_HeavyRain, {
  name: 'heavyRain',
  expression: createPaintExpression('heavyRain'),
  icon: 'weather-rain-warning',
  key: SimulationMetrics.Warnings_HeavyRain,
  displayName: 'Heavy Rain',
  legend: roadHazardLegendObstacles,
})

CustomerMetricMap.set(SimulationMetrics.Warnings_HeavySnow, {
  name: 'heavySnow',
  expression: createPaintExpression('heavySnow'),
  icon: 'ice',
  key: SimulationMetrics.Warnings_HeavySnow,
  displayName: 'Heavy Snow',
  legend: roadHazardLegendObstacles,
})

CustomerMetricMap.set(SimulationMetrics.Warnings_StrongWind, {
  name: 'strongWind',
  expression: createPaintExpression('strongWind'),
  icon: 'wind-vane-moderate',
  key: SimulationMetrics.Warnings_StrongWind,
  displayName: 'Strong Wind',
  legend: roadHazardLegendObstacles,
})

CustomerMetricMap.set(SimulationMetrics.Warnings_PoorRoad, {
  name: 'poorRoad',
  expression: createPaintExpression('poorRoad'),
  icon: 'mold',
  key: SimulationMetrics.Warnings_PoorRoad,
  displayName: 'Poor Road',
  legend: roadHazardLegendObstacles,
})

CustomerMetricMap.set(SimulationMetrics.Warnings_WrongWayDriver, {
  name: 'wrongWayDriver',
  expression: createPaintExpression('wrongWayDriver'),
  icon: 'user-hand-stop',
  key: SimulationMetrics.Warnings_WrongWayDriver,
  displayName: 'Wrong Way Driver',
  legend: roadHazardLegendObstacles,
})

CustomerMetricMap.set(SimulationMetrics.Warnings_ItemOnRoad, {
  name: 'itemOnRoad',
  expression: createPaintExpression('itemOnRoad'),
  icon: 'truck-box',
  key: SimulationMetrics.Warnings_ItemOnRoad,
  displayName: 'Item On Road',
  legend: roadHazardLegendObstacles,
})

CustomerMetricMap.set(SimulationMetrics.Warnings_AmberLightVehicle, {
  name: 'amberLightVehicle',
  expression: createPaintExpression('amberLightVehicle'),
  icon: 'emergency-front',
  key: SimulationMetrics.Warnings_AmberLightVehicle,
  displayName: 'Amber Light',
  legend: roadHazardLegendObstacles,
})

CustomerMetricMap.set(SimulationMetrics.Warnings_BlueLightVehicle, {
  name: 'blueLightVehicle',
  expression: createPaintExpression('blueLightVehicle'),
  icon: 'siren',
  key: SimulationMetrics.Warnings_BlueLightVehicle,
  displayName: 'Blue Light',
  legend: roadHazardLegendObstacles,
})

CustomerMetricMap.set(SimulationMetrics.Warnings_StoppedVehicle, {
  name: 'stoppedVehicle',
  expression: createPaintExpression('stoppedVehicle'),
  icon: 'car',
  key: SimulationMetrics.Warnings_StoppedVehicle,
  displayName: 'Stopped Vehicle',
  legend: roadHazardLegendObstacles,
})

CustomerMetricMap.set(SimulationMetrics.Warnings_TrafficJamTail, {
  name: 'trafficJamTail',
  expression: createPaintExpression('trafficJamTail'),
  icon: 'cars-traffic',
  key: SimulationMetrics.Warnings_TrafficJamTail,
  displayName: 'Traffic Jam Tail',
  legend: roadHazardLegendObstacles,
})
